/**
 * Shared job location formatter for careers listing, filters, and details.
 */

/**
 * @param {string|{city?: string, state?: string, countryCode?: string}|null|undefined} location
 * @param {string} [fallback='']
 * @returns {string}
 */
export function formatJobLocation(location, fallback = '') {
  if (!location) return fallback;

  if (typeof location === 'string') return location;

  const parts = [];
  if (location.city) parts.push(location.city);
  if (location.state) parts.push(location.state);
  if (location.countryCode) parts.push(location.countryCode);

  return parts.join(', ') || fallback;
}
